module.exports = __webpack_public_path__ + "static/media/madevialogo_transparente.67370ec2.webp";